<template>
    <div class="mobile-navigation-button">
        <v-app-bar-nav-icon @click="drawer = !drawer" />

        <teleport to="body">
            <nav
                class="mobile-navigation"
                :class="{ show: drawer }"
            >
                <div class="navigation_container">
                    <v-container>
                        <custom-button
                            @click="drawer = false"
                            class="w-100"
                        >
                            <v-icon icon="mdi-close" />
                        </custom-button>
                        <v-list
                            density="compact"
                            nav
                        >
                            <template
                                v-for="(page, key) in header.pages"
                                :key="key"
                            >
                                <v-list-item
                                    v-if="page.element.children.length === 0"
                                    :to="'/' + page.element.url"
                                    class="font-weight-bold"
                                    @click="drawer = false"
                                >
                                    {{ page.element.urlText }}
                                </v-list-item>
                                <v-list-group
                                    v-else
                                    :value="page.element.url"
                                >
                                    <template v-slot:activator="{ props }">
                                        <v-list-item
                                            v-bind="props"
                                            class="font-weight-bold"
                                        >
                                            {{ page.element.urlText }}
                                        </v-list-item>
                                    </template>
                                    <v-list-item
                                        v-for="(child, k) in page.element.children"
                                        :key="k"
                                        v-bind="getNavigationListItemProps(child)"
                                        @click="drawer = false"
                                    >
                                        <v-list-item-title>
                                            {{ child.urlText }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <hr />
                            </template>
                        </v-list>
                    </v-container>

                    <div class="mobile-navigation-footer">
                        <div
                            v-if="header.additionalButtons"
                            class="button-snackbar"
                            @click="drawer = false"
                        >
                            <navigation-header-desktop-additional-buttons
                                :additional-buttons="header.additionalButtons"
                            />
                        </div>
                    </div>
                </div>
            </nav>
        </teleport>
    </div>
</template>

<script setup>
    import CustomButton from '@/components/reuseables/customButton.vue'
    import { defineProps, ref } from 'vue'
    import NavigationHeaderDesktopAdditionalButtons from '@/components/navigation/navigationHeader/navigationHeaderDesktopAdditionalButtons.vue'
    import { getNavigationListItemProps } from '@/mixins/global/globalMethods'

    defineProps({
        header: {
            type: Object,
            required: true,
        },
    })

    const drawer = ref(false)
</script>

<style lang="scss" scoped>
.mobile-navigation-footer {
    position: absolute;
    bottom: 0;
    z-index: 999;
    background-color: white;
    padding: 1rem 2rem;
    left: 50%;
    transform: translateX(-50%);
}
</style>
